const generateShipmentNumber = require('../../shipment/tools/generate-shipment-number')
const { aggregateQuantitiesBySku, updateCountsFromSkuQuantities } = require('../utils')

function createGrnCreation ({ mainApi, logger, batches }) {
  return async function grnCreation (params) {
    if (!params || !Array.isArray(params.items) || params.items.length === 0) {
      const err = new Error('grnCreation: po_reference parameter is required')
      err.status = 400
      throw err
    }
    const shipmentId = params.items[0].po_reference
    if (!shipmentId) {
      const err = new Error('grnCreation: po_reference parameter is required')
      err.status = 400
      throw err
    }
    let shipment
    try {
      shipment = await mainApi.shipment.getShipmentByNumber({ shipmentNumber: shipmentId })
    } catch (error) {
      const err = new Error(`grnCreation: shipment not found for PO reference: ${shipmentId}: ${error}`)
      err.status = 404
      throw err
    }
    if (!shipment) {
      const err = new Error(`grnCreation: shipment not found for PO reference: ${shipmentId}`)
      err.status = 404
      throw err
    }

    const hasReceivedSnapshot = shipment.status === 'received'

    await batches.fromGrn(params.items)
    const grnQuantitiesBySku = aggregateQuantitiesBySku(
      params.items,
      item => item && item.grn_quantity,
      {
        getBatchEntries: (item) => {
          if (!item) return []
          return [{
            batchNumber: item.batch_number,
            quantity: item.grn_quantity
          }]
        }
      }
    )
    const countsWithGrnQuantities = updateCountsFromSkuQuantities(shipment.counts, grnQuantitiesBySku)

    const baseSnapshot = {
      ...shipment,
      counts: countsWithGrnQuantities,
      doCheckSent: false
    }

    if (hasReceivedSnapshot) {
      const followUpShipmentNo = generateShipmentNumber()
      const followUpSnapshots = await mainApi.shipment.decorateShipmentSnapshotsWithResolvedPrices(['new', 'received'].map(status => ({
        ...baseSnapshot,
        status,
        shipmentNo: followUpShipmentNo,
        parentDocId: shipment.id
      })))
      if (logger && logger.warn) {
        logger.warn({
          code: 'received-snapshot-already-exists',
          orderId: shipment.orderId,
          shipmentId: shipment.id,
          status: shipment.status,
          followUpShipmentNo
        }, 'received snapshot already exists, creating follow ups (new + received)')
      }
      await mainApi.shipment.createBulkSnapshots(followUpSnapshots)
      return
    }

    const [snapshotWithPrices] = await mainApi.shipment.decorateShipmentSnapshotsWithResolvedPrices([{
      ...baseSnapshot,
      status: 'received'
    }])

    await mainApi.shipment.createSnapshot(snapshotWithPrices)
  }
}

module.exports = createGrnCreation
